export default { status: {}, manifest: [] };
